import {
  SET_DICTCONDITION,
  SET_DICTCONDITIONS,
  SET_DICTCONDITIONS_QUERY_PARAMS,
  SET_DICTCONDITIONS_SET_IS_FETCHING,
} from '../constants/conditionsActionsTypes';

const initialState = {
  list: [],
  params: {
    search: '',
  },
  dictCondition: {},
  isFetching: false,
  total: 0,
};

function dictConditions(state = initialState, action) {
  switch (action.type) {
    case SET_DICTCONDITION:
      return {
        ...state,
        dictCondition: action.data,
      };
    case SET_DICTCONDITIONS:
      return {
        ...state,
        list: action.data.dictConditions,
        params: {
          ...state.params,
          ...action.data.params,
        },
        total: action.data.total,
      };
    case SET_DICTCONDITIONS_QUERY_PARAMS:
      return {
        ...state,
        params: {
          ...state.params,
          ...action.params,
        },
      };
    case SET_DICTCONDITIONS_SET_IS_FETCHING:
      return {
        ...state,
        isFetching: action.isFetching,
      };
    default:
      return state;
  }
}

export default dictConditions;
